<svg xmlns="http://www.w3.org/2000/svg" width="22" height="15" viewBox="0 0 22 15">
  <g id="visibility" transform="translate(-1 -4.5)">
    <path id="Path_327" data-name="Path 327" d="M12,4.5A11.782,11.782,0,0,0,1,12a11.817,11.817,0,0,0,22,0A11.782,11.782,0,0,0,12,4.5ZM12,17a5,5,0,1,1,5-5A4.951,4.951,0,0,1,12,17Zm0-8a3,3,0,1,0,3,3A2.946,2.946,0,0,0,12,9Z" fill="#ccc"/>
  </g>
</svg>
